import { useDispatch } from "react-redux";

import {
	setCreateCommunicationStatus,
	setDeleteCommunication,
	getCommunicationHistoryList,
	setUpdateCommunicationStatus,
	setTrafficStatusUpdate,
	getProfileData,
	updateProfileData,
	updateChiefsData,
	clearCommunicationCreateState,
	clearCommunicationDeleteState,
	clearCommunicationUpdateState,
	clearTrafficStatusUpdateState,
	clearProfileState,
	clearUpdateProfileState,
	clearUpdateChiefsState,
	clearCommunicationHistoryState,
	editEmailData,
	clearEditEmailState,
	getAdditionalInfoData,
	clearAdditionalInfoState,
	CommunicationCreatePayloadType,
	CommunicationHistoryPayloadType,
	CommunicationDeletePayloadType,
	TrafficStatusUpdatePayloadType,
	ProfilePayloadType,
	UpdateProfilePayloadType,
	UpdateProfileChiefsPayloadType,
	EditEmailPayloadType,
	getPreviewEmailSentData,
	clearPreviewEmailSentState,
	getNotesData,
	createNoteData,
	updateNoteData,
	deleteNoteData,
	pinUnpinNoteData,
	clearNoteCreateState,
	clearNoteDeleteState,
	clearNoteUpdateState,
	clearNotePinUnpinState,
	updateOtherInfoData,
	updateAccountIdData,
	UpdateAccountIdPayloadType,
	clearUpdateAccountIdState,
	getAccountIdData,
	clearAccountIdState,
	getMultiAccountListData,
	verifyMultiAccountData,
	getMultiAccountVerificationStatusData,
	clearMultiAccountListState,
	clearMultiAccountVerifyState,
	clearMultiAccountVerificationStatusState,
	getTagsData,
	assignTagsData,
	removeTagsData,
} from "./index";

export const useAffProfile = () => {
  const dispatch = useDispatch();

  const getCommunicationHistory = (data: CommunicationHistoryPayloadType) => dispatch(getCommunicationHistoryList(data))
  const createCommunicationStatus = (data: CommunicationCreatePayloadType) => dispatch(setCreateCommunicationStatus(data));
  const deleteCommunicationStatus = (data: CommunicationDeletePayloadType) => dispatch(setDeleteCommunication(data));
  const updateCommunicationStatus = (data: CommunicationCreatePayloadType) => dispatch(setUpdateCommunicationStatus(data));
  const updateTrafficStatus = (data: TrafficStatusUpdatePayloadType) => dispatch(setTrafficStatusUpdate(data));
  const getProfile = (data: ProfilePayloadType) => dispatch(getProfileData(data));
  const updateProfile = (data: UpdateProfilePayloadType) => dispatch(updateProfileData(data));
	const getAccountId = (data: ProfilePayloadType) => dispatch(getAccountIdData(data));
	const clearAccountId = () => dispatch(clearAccountIdState());
  const updateAccountId = (data: UpdateAccountIdPayloadType) => dispatch(updateAccountIdData(data));
	const clearUpdateAccountIdData = () => dispatch(clearUpdateAccountIdState());
  const updateChiefs = (data: UpdateProfileChiefsPayloadType) => dispatch(updateChiefsData(data));
  const getPreviewEmailSent = (data: any) => dispatch(getPreviewEmailSentData(data));

  const editEmail = (data: EditEmailPayloadType) => dispatch(editEmailData(data));
  const clearEditEmail = () => dispatch(clearEditEmailState());

  const getAdditionalInfo = (data: any) => dispatch(getAdditionalInfoData(data));
  const clearAdditionalInfo = () => dispatch(clearAdditionalInfoState());

  const getNotes = (data: any) => dispatch(getNotesData(data));
  const createNote = (data: any) => dispatch(createNoteData(data));
  const updateNote = (data: any) => dispatch(updateNoteData(data));
  const deleteNote = (data: any) => dispatch(deleteNoteData(data));
  const pinUnpinNote = (data: any) => dispatch(pinUnpinNoteData(data));
  const clearNoteCreateData = () => dispatch(clearNoteCreateState());
  const clearNoteDeleteData = () => dispatch(clearNoteDeleteState());
  const clearNoteUpdateData = () => dispatch(clearNoteUpdateState());
  const clearNotePinUnpinData = () => dispatch(clearNotePinUnpinState());

  const clearCommunicationCreate = () => dispatch(clearCommunicationCreateState());
  const clearCommunicationDelete = () => dispatch(clearCommunicationDeleteState());
  const clearCommunicationUpdate = () => dispatch(clearCommunicationUpdateState());
  const clearTrafficStatusUpdate = () => dispatch(clearTrafficStatusUpdateState());
  const clearProfileData = () => dispatch(clearProfileState());
  const clearUpdateProfileData = () => dispatch(clearUpdateProfileState());
  const clearUpdateChiefsData = () => dispatch(clearUpdateChiefsState());
  const clearCommunicationHistoryData = () => dispatch(clearCommunicationHistoryState());
  const clearPreviewEmailSent = () => dispatch(clearPreviewEmailSentState());

  const updateOtherInfo = (data: any) => dispatch(updateOtherInfoData(data));

  //MULTI ACCOUNT
  const getMultiAccountList = (data: any) => dispatch(getMultiAccountListData(data));
  const verifyMultiAccount = (data: any) => dispatch(verifyMultiAccountData(data));
  const getMultiAccountVerificationStatus = (data: any) => dispatch(getMultiAccountVerificationStatusData(data));
  const clearMultiAccountList = () => dispatch(clearMultiAccountListState());
  const clearMultiAccountVerify = () => dispatch(clearMultiAccountVerifyState());
  const clearMultiAccountVerificationStatus = () => dispatch(clearMultiAccountVerificationStatusState());

  //TAGS
  const getTags = (data: any) => dispatch(getTagsData(data));
  const assignTags = (data: any) => dispatch(assignTagsData(data));
  const removeTags = (data: any) => dispatch(removeTagsData(data));

  return {
    getCommunicationHistory,
    createCommunicationStatus,
    deleteCommunicationStatus,
    updateCommunicationStatus,
    updateTrafficStatus,
    getProfile,
	  getAccountId,
    updateProfile,
	  updateAccountId,
    updateChiefs,
    clearCommunicationCreate,
    clearCommunicationDelete,
    clearCommunicationUpdate,
    clearTrafficStatusUpdate,
    clearProfileData,
    clearUpdateProfileData,
    clearUpdateChiefsData,
    clearCommunicationHistoryData,
    editEmail,
    clearEditEmail,
    getAdditionalInfo,
    clearAdditionalInfo,
    getPreviewEmailSent,
    clearPreviewEmailSent,
    getNotes,
    createNote,
    updateNote,
    deleteNote,
    pinUnpinNote,
    clearNoteCreateData,
    clearNoteDeleteData,
    clearNoteUpdateData,
    clearNotePinUnpinData,
    updateOtherInfo,
	  clearUpdateAccountIdData,
	  clearAccountId,
    getMultiAccountList,
    verifyMultiAccount,
    getMultiAccountVerificationStatus,
    clearMultiAccountList,
    clearMultiAccountVerify,
    clearMultiAccountVerificationStatus,
    getTags,
    assignTags,
    removeTags,
  }
}
